const REDACTED_PLACEHOLDER = '<redacted>';
/**
 * Replace the whole string with <redacted> (no partial prefix).
 */
export function redactString(str) {
    return REDACTED_PLACEHOLDER;
}
const SENSITIVE_PARAM_KEYS = [
    'authorization',
    'Authorization',
    'auth',
    'token',
    'accessToken',
    'refreshToken',
    'AWSAccessKeyId',
    'X-Amz-Security-Token',
    'x-amz-security-token',
    'access_token',
    'username',
    'passcode',
];
/** Keys redacted only when context is patient (e.g. network/IP in logs). */
const PATIENT_NETWORK_KEYS = [
    'network',
    'ip',
    'clientIp',
    'client_ip',
    'ipAddress',
    'name',
];
function buildParamPatterns(keys) {
    return keys.map((key) => ({
        json: new RegExp(`("${key}"\\s*:\\s*")(.*?)(")`, 'giu'),
        query: new RegExp(`(${key})=([^&\\s]+)`, 'giu'),
        ablyLog: new RegExp(`(${key}\\s*:\\s*)([^;\\s]+)`, 'giu'),
    }));
}
const SENSITIVE_PARAM_PATTERNS = buildParamPatterns(SENSITIVE_PARAM_KEYS);
const PATIENT_NETWORK_PATTERNS = buildParamPatterns(PATIENT_NETWORK_KEYS);
export const redactSensitiveString = (input, forPatient) => {
    let result = input;
    const patterns = forPatient === true
        ? [...SENSITIVE_PARAM_PATTERNS, ...PATIENT_NETWORK_PATTERNS]
        : SENSITIVE_PARAM_PATTERNS;
    for (const { json, query, ablyLog } of patterns) {
        result = result.replace(json, (_match, prefix, value, suffix) => `${prefix}${redactString(value)}${suffix}`);
        result = result.replace(query, (_match, paramName, paramValue) => `${paramName}=${redactString(paramValue)}`);
        result = result.replace(ablyLog, (_match, prefix, value) => `${prefix}${redactString(value)}`);
    }
    return result;
};
function getKeysToRedact(forPatient) {
    return forPatient
        ? [...SENSITIVE_PARAM_KEYS, ...PATIENT_NETWORK_KEYS]
        : SENSITIVE_PARAM_KEYS;
}
export const redactSensitiveFields = (value, forPatient) => {
    if (value === null || value === undefined) {
        return value;
    }
    const keysToRedact = getKeysToRedact(forPatient);
    if (typeof value === 'string') {
        return redactSensitiveString(value, forPatient);
    }
    if (typeof value === 'object') {
        const obj = value;
        for (const key of Object.keys(obj)) {
            const fieldValue = obj[key];
            if (keysToRedact.includes(key)) {
                const asString = typeof fieldValue === 'string'
                    ? fieldValue
                    : fieldValue !== null && fieldValue !== undefined
                        ? String(fieldValue)
                        : '';
                obj[key] = redactString(asString);
                continue;
            }
            if (typeof fieldValue === 'string') {
                obj[key] = redactSensitiveString(fieldValue, forPatient);
                continue;
            }
            if (fieldValue !== null && typeof fieldValue === 'object') {
                redactSensitiveFields(fieldValue, forPatient);
            }
        }
    }
    return value;
};
/**
 * Strip patient PII from Angular $http rejection objects before console/Datadog logging.
 */
export function sanitizePatientHttpErrorForLogging(err) {
    if (err === null || err === undefined || typeof err !== 'object') {
        return err;
    }
    const httpErr = err;
    const safe = {
        status: httpErr.status,
        statusText: httpErr.statusText,
        xhrStatus: httpErr.xhrStatus,
        data: httpErr.data,
    };
    if (httpErr.config) {
        safe.config = {
            method: httpErr.config.method,
            url: httpErr.config.url,
        };
    }
    return safe;
}
